import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import useStore from "./Store";

const GetInfo = () => {
  const { gl } = useThree();
  const setRenderer = useStore((state) => state.setRenderer);

  useEffect(() => {
    // gl === WebGLRenderer
    // gl.info.calls
    setRenderer(gl);
  });
  return null;
};

export default GetInfo;
